import update from 'immutability-helper'
import React from 'react'
import {useHistory} from 'react-router-dom'
import { makeStyles, withStyles} from 'external/material'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import AddIcon from '@mui/icons-material/Add'
import create from 'helpers/command'
import {initQuestion} from 'helpers/quiz'

const AddButton = withStyles({
  root: {
    borderColor: '#fff7ea',
    backgroundColor: '#fff7ea',
    borderRadius: 0,
    color: '#68728b',
    '& svg': {
      marginTop: -3
    },
    '&:hover': {
      backgroundColor: '#ccbda5',
      borderColor: '#ccbda5',
      boxShadow: 'none',
    },
  },
  label: {
    textTransform: 'none'
  }
})(Button)

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexGrow: 1,
  },
  button: {
    flexGrow: 1
  },
  menu: {
  },
  addIcon: {
    fontSize: '14pt'
  }
}))


const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

export default function AddQuestion ({context, section}) {

  const {link, assessment: assessmentId, updateState} = context
  const classes = useStyles()
  const history = useHistory()
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  async function addQuestion (questionType) {
    const [data] = await create('quiz', 'addQuestion')({type: questionType.id, section: section.id})
    if (data) {
      const question = update(data, {isNew: {$set: true}})
      const init = initQuestion(context)
      const quizQuestions = context.quizQuestions[section.id]
        ? update(context.quizQuestions, {[section.id]: {$push: [init(question)]}})
        : update(context.quizQuestions, {[section.id]: {$set: [init(question)]}})
      context.setState({quizQuestions})
      history.push(link({questionId: question.id}))
    }
    handleClose()
  }

  function handleSearchQuestion () {
    updateState({
      quizDialogs: {'search-and-select-question': {$set: true}},
      searchAndSelectSection: {$set: section.id}
    })
    handleClose()
  }

  return (
    <div className={classes.root}>
      <AddButton
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        color="primary"
        onClick={handleClick}
        className={classes.button}
      >
        <AddIcon className={classes.addIcon}/>{context.translate('add-question')}
      </AddButton>
      <Menu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {context.quizQuestionTypes.map((questionType, index) => {
          return <MenuItem key={index} onClick={() => addQuestion(questionType)}>{context.translate(questionType.name)}</MenuItem>
        })}
        <MenuItem onClick={handleSearchQuestion}>{context.translate('question-bank')}</MenuItem>
      </Menu>
    </div>
  )
}

        //{true && (// removed-dreyfous-filter context.profile.domain == 'dreyfous' }
